<template>
  <header class="header">
    <div class="header__wrapper">
      <span class="header__name">dealer order system</span>
    </div>
    <div class="header__wrapper header__wrapper_actions">
      <div />
      <div />
      <router-link to="/search">
        <div class="search">
          <img src="@/assets/images/search.svg">
        </div>
      </router-link>
      <router-link to="/cart">
        <div class="basket">
          <img src="@/assets/images/basket.svg">
          <span class="basket__count">{{ cart.length }}</span>
        </div>
      </router-link>
    </div>
    <div class="header__wrapper">
      <locale-switch />
    </div>
    <div class="header__wrapper">
      <div
        v-if="user"
        class="header__user"
      >
        <span class="header__user__login">{{ user.name }}</span>
        <div class="header__user__modal">
          <div class="header__user__modal__content">
            <router-link
              v-if="user.asdb && workMode.isModeSollers"
              to="/dealer"
              class="header__user__modal__link mb-n4"
            >
              {{ $t('common.my_profile') }}
            </router-link>

            <a
              class="header__user__modal__link"
              @click.prevent="passwordModal = true"
            >
              {{ $t('common.change_password') }}
            </a>

            <v-btn
              color="primary"
              outlined
              @click="signOut"
            >
              {{ $t('common.sign_out') }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <password-modal v-model="passwordModal" />
  </header>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import LocaleSwitch from '@/components/common/LocaleSwitch';
import PasswordModal from '@/components/profile/PasswordModal';

export default {
  name: 'AppHeader',
  components: {
    LocaleSwitch,
    PasswordModal,
  },
  data: () => ({
    passwordModal: false,
  }),
  computed: {
    ...mapState(['user', 'cart', 'workMode']),
    ...mapGetters(['read']),
  },
  methods: {
    signOut() {
      this.$router.push('/sign-in');
      this.$store.commit('signOut', this.$keycloak);
    },
  },
};
</script>

<style lang="scss">
.header {
  min-height: 80px;
  background-color: var(--black);
  display: flex;
  column-gap: normal;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;

  &__name {
    text-transform: uppercase;
    font-weight: 300;
    font-size: 30px;
    color: #9b9b9b;
  }

  &__user {
    $user: &;
    position: relative;

    &__login {
      position: relative;
      cursor: pointer;
      padding-right: 25px;
      color: #fff;
      font-size: 20px;
      font-weight: 300;
      white-space: nowrap;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 220px;

      &::after {
        content: "";
        position: absolute;
        top: calc(50% - 2px);
        right: 0;
        border: 8px solid transparent;
        border-top: 8px solid #fff;
      }
    }

    &__modal {
      opacity: 0;
      position: absolute;
      right: 0;
      width: 100%;
      max-width: 220px;
      z-index: 2;
      min-width: 200px;
      padding: 15px 0 0 0;
      pointer-events: none;
      transition: opacity 0.3s ease-in-out;

      &__content {
        display: grid;
        row-gap: 25px;
        justify-content: center;
        background-color: #f8f6f5;
        padding: 20px 15px;
        box-shadow: 0 0 5px 5px #0000001c;
        transform: translateY(-10px);
        transition: transform 0.3s ease-in-out;
      }

      &__link {
        font-size: 18px;
        text-align: center;
        color: var(--topaz);
        transition: color 0.3s ease-in-out;

        &:hover {
          color: var(--aurum);
          text-decoration: none;
        }
      }

      &__exit {
        padding: 5px 25px;
      }
    }

    &:hover {
      #{$user}__modal {
        opacity: 1;
        pointer-events: initial;
      }

      #{$user}__modal__content {
        transform: translateY(0);
      }
    }
  }

  &__wrapper {
    &_actions {
      display: grid;
      grid-template-columns: auto repeat(3, 80px);
    }
  }

  .search,
  .basket {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      user-select: none;
      cursor: pointer;
    }
  }

  .basket {
    padding-right: 5px;
    position: relative;

    &_active {
      background-color: #000;
    }

    &__wrapper {
      position: relative;
    }

    &__count {
      top: 12px;
      right: 14px;
      position: absolute;
      background-color: var(--aurum);
      color: #fff;
      border-radius: 50%;
      min-width: 23px;
      border: 2px solid var(--black);
      height: 23px;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .search {
    &_active {
      background-color: #000;
    }
  }

  .locale-switch {
    transform: translateY(-10px);
  }
}
</style>
